import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    inventory: [],
    loading: false,
    error: null,
};

const inventorySlice = createSlice({
    name: 'inventory',
    initialState,
    reducers: {
        setInventory: (state, action) => {
            state.inventory = action.payload;
        },
        addInventoryItem: (state, action) => {
            state.inventory.push(action.payload);
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setInventory, addInventoryItem, setLoading, setError } = inventorySlice.actions;
export default inventorySlice.reducer;
